import React, { PureComponent } from 'react';
import { Line } from 'rc-progress/lib';
import bytes from 'bytes';

import { Button, ResponsiveTable } from '..';
import { ImageresizeApi } from 'modules';
import { simplifyUrl } from 'utils';

import CloseIcon from 'assets/icons/close.svg';
import DownloadIcon from 'assets/icons/download.svg';

import styles from './styles';

export default class BulkList extends PureComponent {

  getColumns() {
    const { type = 'upload' } = this.props;
    const columns = {
      fileName: {
        filter: simplifyUrl,
        grow: true,
        heading: 'File Name'
      },
      status: {
        bold: true,
        heading: 'Status',
        width: '130px'
      },
      action: {
        heading: 'Action',
        width: '80px'
      },
      size: {
        heading: 'Old Size',
        width: '110px'
      }
    };

    if (type === 'compress') {
      columns.newSize = {
        bold: true,
        heading: 'New Size',
        width: '110px'
      };
      columns.saved = {
        bold: true,
        heading: 'Saved',
        width: '70px'
      };
    }

    return columns;
  }

  renderSavings({ contentLength, newContentLength }) {

    if (!contentLength || !newContentLength) {
      return '--';
    }

    const savings = 1 - (newContentLength / contentLength);

    return `${Math.round(savings * 100)}%`;
  }

  renderProgressBar({ text, color, percent = 100 }) {
    return (
      <div className={ styles.progressBar }>
        <div className={ styles.progressBarText }>{ text }</div>
        <Line
          className="progressBar"
          percent={ percent }
          strokeColor={ color }
          strokeLinecap="square"
          strokeWidth="20"
          trailColor="#d3d6d8"
          trailWidth="20"
        />
      </div>
    );
  }

  renderStatus({ uploadProgress, state }) {

    if (state === 'ready') {
      return (
        <span className={ styles.successStatus }>
          Ready
        </span>
      );
    }

    if (state === 'done') {
      return (
        <span className={ styles.successStatus }>
          Done
        </span>
      );
    }

    if (state === 'archiving') {
      return this.renderProgressBar({
        text: 'Archiving',
        color: '#f5c723'
      });
    }

    if (state === 'uploaded') {
      return this.renderProgressBar({
        text: 'Uploaded',
        color: '#9ad86d'
      });
    }

    if (state === 'compressing') {
      return this.renderProgressBar({
        text: 'Compressing',
        color: '#f5c723'
      });
    }

    return this.renderProgressBar({
      text: 'Uploading',
      color: '#5db5f8',
      percent: uploadProgress * 100
    });
  }

  renderAction({ id, newImageId, name, state }) {
    const { removeImage } = this.props;

    if (state === 'done') {
      return (
        <a
          href={ ImageresizeApi.getImageUrl(newImageId, name) }
          target="_blank"
        >
          <DownloadIcon height="20" width="20" />
        </a>
      );
    }

    return (
      <Button
        onClick={ removeImage }
        clickProps={ [id] }
      >
        <CloseIcon height="20" width="20" />
      </Button>
    );
  }

  render() {
    const { images } = this.props;
    const columns = this.getColumns();
    const rows = images.map((image) => ({
      fileName: image.name,
      status: this.renderStatus(image),
      action: this.renderAction(image),
      size: image.contentLength ? bytes(image.contentLength) : '--',
      newSize: image.newContentLength ? bytes(image.newContentLength) : '--',
      saved: this.renderSavings(image)
    }));

    return (
      <div className="selection-box">
        <ResponsiveTable
          columns={ columns }
          rows={ rows }
          type="rounded"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BulkList/index.jsx